import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { RootScopeService } from './root-scope.service';
import { Global } from '../global/globalApi';
import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import * as Constants from '../models/Constants';

@Injectable({
  providedIn: 'root'
})
export class AccountFreezeService {

  constructor(public rootScope: RootScopeService, private http: HttpClient) { }

   /**
   * Sauth =true then only call the getPreAuthUserData API and then getALerts API should be triggered.
   * Sauth= false , directly call getALerts API .
   * CCR1-8142
   * @returns 
   */

  getAccountFreezeStatusFromServer() {

    let securityModel = this.rootScope.getSecurityModel(this.rootScope.activeCustTab.clientId);
    if (securityModel?.toLowerCase() == 'sauth') {
      if (this.rootScope.activeCustTab.personStatus != 'NA') {
        this.rootScope.activeCustTab.loadDisplayAlertComp = true; /**Handling case of refresh the application for display alerts */
        return;
      }

      console.log('fraud invoking preAuth Config API', this.rootScope.activeCustTab);
      this.getData().subscribe({
        next: (data: any) => {
          if (data?.data && data?.data?.personStatus) {
            this.rootScope.activeCustTab.personStatus = data?.data?.personStatus;
          }
          this.rootScope.activeCustTab.loadDisplayAlertComp = true; /** Flag used for displayAlerts API call  */
        },
        error: (error) => {
          this.rootScope.activeCustTab.loadDisplayAlertComp = true;
        }
      });
    }
    else {
      /**If Sauth false , then direcly call getAlerts API */
      this.rootScope.activeCustTab.loadDisplayAlertComp  = true;
    }
  }

  getData() {

    let url = Global.domainUrl + Global.GET_PRE_AUTH_IDENTIFY_USER;
    let reqBody = {
      clientId: this.rootScope.activeCustTab.clientId
    }
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
    });
  }
}
